import { render, staticRenderFns } from "./userprofile.vue?vue&type=template&id=e8c85ac8&scoped=true&"
import script from "./userprofile.vue?vue&type=script&lang=js&"
export * from "./userprofile.vue?vue&type=script&lang=js&"
import style0 from "./userprofile.vue?vue&type=style&index=0&id=e8c85ac8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c85ac8",
  null
  
)

export default component.exports